export default __webpack_public_path__ + "static/media/hht1_song_03.8eb6c6de.png";